module.exports = __webpack_public_path__ + "img/header_background.b0cc9346.png";